export default "__VITE_ASSET__BfCHPTCw__"